import React from 'react';
import { Check } from 'lucide-react';
export const CTASection = () => {
  return <section className="w-full bg-pink-50 px-5 py-10" data-id="element-102">
      <div className="max-w-md mx-auto" data-id="element-103">
        <h2 className="text-2xl font-bold text-pink-900 mb-7 text-center leading-tight" data-id="element-104">
          Take Control of Your Intimate Health Today
        </h2>
        <div className="bg-white rounded-xl p-6 shadow-md mb-8" data-id="element-105">
          <p className="text-lg font-bold text-center text-pink-800 mb-5 leading-tight" data-id="element-106">
            Special Offer: Save 25% on the 3-Pouch Bundle – our best value for
            complete restoration
          </p>
          <div className="space-y-3 mb-6" data-id="element-107">
            <BenefitCheck text="90-Day Money-Back Guarantee" data-id="element-108" />
            <BenefitCheck text="Made in USA, GMP-Certified Facility" data-id="element-109" />
            <BenefitCheck text="100% Natural, Hormone-Free Ingredients" data-id="element-110" />
            <BenefitCheck text="Safe with other supplements & medications" data-id="element-111" />
            <BenefitCheck text="Trusted by 79,000+ Women" data-id="element-112" />
            <BenefitCheck text="Just 2 delicious gummies a day" data-id="element-113" />
            <BenefitCheck text="Free shipping, no hidden fees" data-id="element-114" />
          </div>
          <div className="bg-blue-50 rounded-xl p-5 mb-6 shadow-sm" data-id="element-115">
            <p className="text-gray-700 italic mb-2 leading-relaxed" data-id="element-116">
              💬 "I wish I hadn't waited. I wasted so much time thinking this
              was just my new, miserable normal. It's not. Don't wait."
            </p>
            <p className="text-gray-700 font-semibold text-sm" data-id="element-117">– Erica C.</p>
          </div>
          <a href="https://mynuora.com/products/feminine-balance-gummies-1" target="_blank" rel="noopener noreferrer" data-id="element-118">
            <button className="bg-pink-600 hover:bg-pink-700 transition-colors text-white font-bold py-4 px-6 rounded-full w-full mb-7 shadow-md" data-id="element-119">
              GET STARTED NOW
            </button>
          </a>
          <div className="space-y-3 mb-7" data-id="element-120">
            <h3 className="font-bold text-gray-800 text-lg mb-3" data-id="element-121">
              Imagine in just 90 days:
            </h3>
            <BenefitCheck text="Saying 'yes' to your partner with genuine desire and zero fear" data-id="element-122" />
            <BenefitCheck text="Feeling comfortable and confident in your own skin, all day long" data-id="element-123" />
            <BenefitCheck text="Forgetting that lubricants even exist" data-id="element-124" />
            <BenefitCheck text="Feeling vibrant, sensual, and in control of your body again" data-id="element-125" />
          </div>
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-126">
            Because every day you wait, the internal deficit gets worse. The
            walls get thinner, and the path back to comfort gets longer.
          </p>
          <p className="text-lg font-bold text-pink-800 leading-relaxed" data-id="element-127">
            But when you start Nuora today... <i data-id="element-128">you get your body back.</i>
          </p>
        </div>
      </div>
    </section>;
};
const BenefitCheck = ({
  text
}: {
  text: string;
}) => {
  return <div className="flex items-start" data-id="element-129">
      <div className="bg-green-100 rounded-full p-1.5 mr-3 mt-0.5 flex-shrink-0" data-id="element-130">
        <Check className="h-4 w-4 text-green-600" data-id="element-131" />
      </div>
      <p className="text-gray-700 leading-relaxed" data-id="element-132">{text}</p>
    </div>;
};